module.exports = __webpack_public_path__ + "img/sankaku_32_red.68ea1045.png";